// 1. 타이핑 애니메이션 효과
document.addEventListener('DOMContentLoaded', function() {
    const textElement = document.getElementById('fh-typing-text');
    if(!textElement) return;

    const phrases = [
        "FURNIHUNTER PRESENTS",
        "FIND YOUR INSPIRATION",
        "SHARE YOUR ROOM STYLE",
        "CONNECT WITH CREATORS"
    ];
    
    let phraseIndex = 0; let charIndex = 0; let isDeleting = false; let typeSpeed = 100;

    function typeEffect() {
        const currentPhrase = phrases[phraseIndex];
        if (isDeleting) {
            textElement.textContent = currentPhrase.substring(0, charIndex - 1);
            charIndex--; typeSpeed = 50;
        } else {
            textElement.textContent = currentPhrase.substring(0, charIndex + 1);
            charIndex++; typeSpeed = 100;
        }

        if (!isDeleting && charIndex === currentPhrase.length) {
            isDeleting = true; typeSpeed = 2000;
        } else if (isDeleting && charIndex === 0) {
            isDeleting = false; phraseIndex = (phraseIndex + 1) % phrases.length; typeSpeed = 500;
        }
        setTimeout(typeEffect, typeSpeed);
    }
    typeEffect();
});

// 2. 파이어베이스 데이터 로직
import { initializeApp } from "https://www.gstatic.com/firebasejs/10.7.1/firebase-app.js";
import { getFirestore, collection, query, where, getDocs, doc, getDoc, updateDoc, arrayRemove } from "https://www.gstatic.com/firebasejs/10.7.1/firebase-firestore.js";

const firebaseConfig = {
    apiKey: "AIzaSyA2UxM1a1Muy7PquZPP3pc6QyU4PAXwjF0",
    authDomain: "furnihunter-community-jp.firebaseapp.com",
    projectId: "furnihunter-community-jp",
    storageBucket: "furnihunter-community-jp.firebasestorage.app",
    messagingSenderId: "573529217034",
    appId: "1:573529217034:web:c6d6a407e49d06e1ce27f3",
    measurementId: "G-LEMD9XJJNB"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// 🚨 HTML에서 넘겨준 Liquid 데이터를 받아옵니다.
const currentUserId = window.myPageData.userId; 

window.switchTab = function(tabName) {
    document.querySelectorAll('.mp-tab-btn').forEach(btn => btn.classList.remove('active'));
    document.getElementById('btn-' + tabName)?.classList.add('active');

    ['Posts', 'Followers', 'Following', 'Scraps'].forEach(name => {
        document.getElementById('tab' + name).classList.add('hidden');
    });

    const targetTab = 'tab' + tabName.charAt(0).toUpperCase() + tabName.slice(1);
    document.getElementById(targetTab).classList.remove('hidden');

    if(tabName === 'followers') loadMyFollowers();
    else if(tabName === 'following') loadMyFollowing();
    else if(tabName === 'scraps') loadMyScraps();
};

function formatCount(num) {
    if (!num) return 0;
    if (num >= 1000) return (num / 1000).toFixed(1) + 'K';
    return num;
}

function renderGrid(containerId, docs, emptyMsg) {
    const container = document.getElementById(containerId);
    container.innerHTML = "";
    
    if(!docs || docs.length === 0) {
        container.innerHTML = `<div class="mp-empty">${emptyMsg}</div>`;
        return;
    }

    docs.forEach(d => {
        const data = d.data();
        if (!data.content || !Array.isArray(data.content) || data.content.length === 0) return;
        const first = data.content[0];
        const mediaUrl = first.thumbnail || first.url || first.image;
        if (!mediaUrl) return;

        const div = document.createElement('div');
        div.className = 'mp-grid-item';
        div.onclick = () => location.href = `/pages/community?post_id=${d.id}`;
        
        const pinCount = data.content.reduce((acc, cur) => acc + (cur.hotspots ? cur.hotspots.length : 0), 0);
        const pinBadge = pinCount > 0 ? `<div style="position:absolute; top:8px; left:8px; background:rgba(0,0,0,0.6); color:#fff; font-size:10px; padding:2px 6px; border-radius:10px; display:flex; align-items:center; gap:2px;">📍 ${pinCount}</div>` : '';

        let mediaHtml = `<img src="${mediaUrl}" class="mp-grid-img" loading="lazy">`;
        let iconHtml = '';
        if(first.type === 'video') {
            mediaHtml = `<video src="${mediaUrl}" class="mp-grid-img" muted></video>`;
            iconHtml = `<div class="mp-video-mark">▶</div>`;
        }

        div.innerHTML = `${mediaHtml}${iconHtml}${pinBadge}`;
        container.appendChild(div);
    });
}

async function loadMyData() {
    if(!currentUserId) return location.href = '/account/login';

    const myDocRef = doc(db, "users", currentUserId);
    const myDoc = await getDoc(myDocRef);
    let displayName = window.myPageData.userName; 

    if(myDoc.exists()) {
        const u = myDoc.data(); 
        if(u.nickname) {
            displayName = u.nickname;
            document.getElementById('myName').innerText = u.nickname;
        }
        const badgeHtml = u.isVerified ? `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-left:6px; flex-shrink:0;"><g><path fill="#000000" d="M22.5,12.5c0-1.58-0.875-2.95-2.148-3.6c0.154-0.435,0.238-0.905,0.238-1.4c0-2.21-1.71-3.998-3.818-3.998 c-0.47,0-0.92,0.084-1.336,0.25C14.818,2.415,13.51,1.5,12,1.5S9.184,2.417,8.563,3.75C8.148,3.585,7.697,3.5,7.227,3.5 c-2.11,0-3.818,1.79-3.818,4c0,0.495,0.083,0.965,0.238,1.4C2.375,9.55,1.5,10.92,1.5,12.5c0,1.435,0.716,2.69,1.77,3.46 c-0.128,0.45-0.2,0.93-0.2,1.415c0,2.21,1.71,4,3.818,4c0.47,0,0.92-0.086,1.336-0.252C8.865,22.5,10.171,23.417,11.682,23.417 S14.497,22.5,15.119,21.167c0.415,0.165,0.865,0.25,1.336,0.25c2.11,0,3.818-1.79,3.818-4c0-0.485-0.072-0.965-0.2-1.415 C21.175,15.22,22.5,13.935,22.5,12.5z"/><path fill="#FFFFFF" d="M10,17.4l-4.2-4.2l1.4-1.4l2.8,2.8l6.4-6.4l1.4,1.4L10,17.4z"/></g></svg>` : '';
        document.getElementById('myName').innerHTML = `${displayName}${badgeHtml}`;
        
        const avt = document.getElementById('myAvatar');
        if(u.avatarUrl) {
            avt.style.backgroundImage = `url('${u.avatarUrl}')`;
            avt.innerText = '';
        } else {
            avt.style.backgroundImage = 'none';
            avt.innerText = displayName.charAt(0).toUpperCase();
        }
        document.getElementById('myBio').innerText = u.bio || "No bio yet.";
        if(u.following) document.getElementById('cntFollowing').innerText = u.following.length;
        if(u.followers) document.getElementById('cntFollowers').innerText = u.followers.length;
    }

    try {
        const q1 = query(collection(db, "posts"), where("userId", "==", String(currentUserId)));
        const snap1 = await getDocs(q1);
        let allDocs = snap1.docs;

        if(snap1.empty) {
            const q2 = query(collection(db, "posts"), where("userId", "==", Number(currentUserId)));
            const snap2 = await getDocs(q2);
            allDocs = snap2.docs;
        }

        allDocs = allDocs.filter(doc => !doc.data().isDeleted);
        const sortedDocs = allDocs.sort((a, b) => new Date(b.data().date) - new Date(a.data().date));
        
        document.getElementById('cntPosts').innerText = sortedDocs.length;
        
        let totalReceived = 0;
        sortedDocs.forEach(d => { if(d.data().likes) totalReceived += d.data().likes.length; });
        const likesEl = document.getElementById('cntTotalLikes');
        if(likesEl) likesEl.innerText = formatCount(totalReceived);

        renderGrid('tabPosts', sortedDocs, "投稿がまだありません");
        
    } catch (e) {
        console.error("Post Load Error:", e);
    }
}

async function loadMyScraps() {
    const box = document.getElementById('tabScraps');
    box.innerHTML = '<div class="mp-empty">Loading...</div>'; 
    try {
      const q = query(collection(db, "posts"), where("scraps", "array-contains", String(currentUserId)));
      const snap = await getDocs(q);
      const validDocs = snap.docs.filter(doc => !doc.data().isDeleted);
      const sortedDocs = validDocs.sort((a, b) => new Date(b.data().date) - new Date(a.data().date));
      renderGrid('tabScraps', sortedDocs, "スクラップした投稿がありません");
    } catch(e) { console.error(e); }
}

async function loadMyFollowers() {
    const box = document.getElementById('tabFollowers');
    box.innerHTML = '<div class="mp-empty">Loading...</div>';
    const myDoc = await getDoc(doc(db, "users", currentUserId));
    if(!myDoc.exists() || !myDoc.data().followers || myDoc.data().followers.length === 0) {
        box.innerHTML = '<div class="mp-empty">フォロワーがいません</div>'; return;
    }
    renderUserList(box, myDoc.data().followers, false);
}

async function loadMyFollowing() {
    const box = document.getElementById('tabFollowing');
    box.innerHTML = '<div class="mp-empty">Loading...</div>';
    const myDoc = await getDoc(doc(db, "users", currentUserId));
    if(!myDoc.exists() || !myDoc.data().following || myDoc.data().following.length === 0) {
        box.innerHTML = '<div class="mp-empty">フォロー中のユーザーがいません</div>'; return;
    }
    renderUserList(box, myDoc.data().following, true);
}

async function renderUserList(container, userIds, showUnfollow) {
    container.innerHTML = "";
    const promises = userIds.map(uid => getDoc(doc(db, "users", uid)));
    const userDocs = await Promise.all(promises);
    
    userDocs.forEach(uDoc => {
        if(!uDoc.exists()) return;
        const u = uDoc.data();
        const div = document.createElement('div');
        div.className = 'mp-user-item';
        
        const rightBtnHtml = showUnfollow 
            ? `<button class="mp-btn-action" onclick="location.href='/pages/community?profile_id=${u.id}'">Profile ></button>` 
            : ''; 

        div.innerHTML = `
            <div class="mp-u-left" onclick="location.href='/pages/community?profile_id=${u.id}'">
                <div class="mp-u-avt" style="${u.avatarUrl ? `background-image:url('${u.avatarUrl}')` : ''}">
                    ${u.avatarUrl ? '' : (u.nickname||u.name||'U').charAt(0)}
                </div>
                <div style="font-weight:600; font-size:14px;">${u.nickname||u.name||'Unknown'}</div>
            </div>
            ${rightBtnHtml}
        `;
        container.appendChild(div);
    });
}

window.unfollowUser = async function(targetId, btn) {
    if(!confirm("Unfollow?")) return;
    try { await updateDoc(doc(db, "users", currentUserId), { following: arrayRemove(targetId) }); btn.closest('.mp-user-item').remove(); } catch(e) {}
}

loadMyData();